export const enum QuizEnumTypes {
  QUESTIONS = 'questions__a',
}
